import { z } from "zod";

/**
 * Payroll schemas (Business Logic §11). The nightly cron POSTs an empty body,
 * so the run schema defaults the whole object — a missing `data` is a valid
 * "run yesterday" request.
 */
export const runPayrollSchema = z
  .object({
    /** Day to compute (YYYY-MM-DD); omitted = yesterday (the nightly default). */
    day: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, "YYYY-MM-DD")
      .optional(),
  })
  .default({});

export type RunPayrollInput = z.infer<typeof runPayrollSchema>;

/** Approve / mark-paid carry no payload — the run id rides in the path. */
export const payrollRunActionSchema = z.object({});

export type PayrollRunActionInput = z.infer<typeof payrollRunActionSchema>;
